import { render } from "./TargetList.vue?vue&type=template&id=592b85ff"
import script from "./TargetList.vue?vue&type=script&lang=js"
export * from "./TargetList.vue?vue&type=script&lang=js"

import "./TargetList.vue?vue&type=style&index=0&id=592b85ff&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__